import { Component, OnInit,ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from 'app/shared/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/shared/services/auth.service';
import { Router} from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';





@Component({
  selector: 'app-user-types',
  templateUrl: './user-types.component.html',
  styleUrls: ['./user-types.component.css']
})
export class UserTypesComponent implements OnInit {

  displayedColumns: string[] = ['userType','createdBy','action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  data : any[];  
  isDark: boolean = false;

  userType : any;
  userTypeForm: FormGroup;
  isValidFormData: boolean = true;
  showProcessingIndicator = false;


  validationMessages = {
    'userType': { 'required': 'User Type is required' },
  };

  formErrors = {
    'userType': "",
  };

  constructor(private fb: FormBuilder,
    private userService: UserService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private router : Router,
    private authService: AuthService,
    private themeService: NbThemeService,
  ) { }

  ngOnInit(): void {

    this.getUserTypeList();
    this.initTypeNForm();

    this.userTypeForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.userTypeForm);
    });


      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
          });
		  

  } // end oninit

  initTypeNForm(){
    this.userType = {
      userType: '',
      createdBy : '',
      companyName : '',
    }

    this.userTypeForm = this.fb.group({
      userType: ['', Validators.required],    
      createdBy: [''],
    });
  }

  newButtonClick(): void {
    this.userTypeForm.reset();

  }

  saveButtonClick(): void {

    this.logValidationErrors(this.userTypeForm, true);
    this.mapFormValuesToModel();

    if (this.isFilledFromFields()) {

        this.showProcessingIndicator = true;
        this.userService.addUserType(this.userType)
          .subscribe(
            (res) => {

              if(res.success === 0){
                this.toastr.error(res.message, 'warning');
                this.showProcessingIndicator = false;
              }else if(res.success === 1){
                this.toastr.success('User type added successfully', 'Success');
                this.showProcessingIndicator = false;
                this.getUserTypeList();
                this.newButtonClick()
                console.log(res);
              }
                         
            },
            (err) => {
              this.toastr.error('Failed to add user type', 'Failure');
              this.showProcessingIndicator = false;
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            },
          )
      } else {  
          this.toastr.warning('Required Fields cannot be empty or invalid.', 'Error Message');
          this.showProcessingIndicator = false;
    }


  }


  enableForm(): void {
    Object.keys(this.userTypeForm.controls).forEach(key => {
      this.userTypeForm.controls[key].enable();
      console.log(key)
    });
  }


  logValidationErrors(group: FormGroup = this.userTypeForm, isDirty: boolean = false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (isDirty) {
        this.enableForm();
        this.userTypeForm.controls[key].markAsTouched();
      }
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.validationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });
  }


  isFilledFromFields(): boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
        return false;
    }
    return true;
  }

  mapFormValuesToModel() {
    this.userType.userType = this.userTypeForm.value.userType;
    this.userType.createdBy = this.authService.getUserLoggedIn();

  }




    ///// User Types List 

    getUserTypeList(){
      this.userService.getAllUserTypes()
       .subscribe(
          (data) => {
                    this.data = data;
                    this.dataSource = new  MatTableDataSource (this.data);  
                    this.dataSource.sort = this.sort;
                    this.dataSource.paginator = this.paginator;  
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });  
         
       }


       deleteButtonClick(id : number){
        this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
        .afterClosed().subscribe(res =>{
          if(res){
            this.userService.deleteUserType(id)
          .subscribe(
            (res) => {
                        this.toastr.success('User type deleted','Success');
                        this.getUserTypeList()
                        console.log(res);     
                      },        
            (err) =>  {
                        this.toastr.error('Failed to delete record','Failure');
                        if(err instanceof HttpErrorResponse){                 
                          if(err.status == 401){
                            this.router.navigate(['/login']);
                          }
                        }
                        console.log(err);
                      }, 
              )
          }
        });            
    }
  
    applyFilter(){
      this.dataSource.filter =this.searchKey.trim().toLowerCase();
  
    }
    onSearchClear(){
      this.searchKey = "";
      this.applyFilter();
    }








} // end class
